export enum RoleEnum {
  Teacher = 'teacher',
  Guardian = 'guardian',
  Staff = 'staff',
  Student = 'student',
  Shadow = 'shadow',
}
